import { ErrorToast, getConfig, handleApiError } from "../Util";
import Axios from "../WebClient";

export const LoginAction = (
  enrollment,
  password,
  setError,
  handleLoginSuccess
) => {
  Axios.post("/auth/login", {
    enrollment,
    password,
  })
    .then((res) => {
      console.log("Login response: ", res.data);
      handleLoginSuccess(res.data.data);
    })
    .catch((err) => {
      handleApiError(err, setError);
      console.log("Error: ", err);
    });
};

export const SignUpMonazzam = (
  values,
  setError,
  setLoading,
  setSuccessMessage,
  handleSignupSuccess
) => {
  Axios.post("/auth/register-monazam", values)
    .then((res) => {
      console.log("Signup response: ", res.data);
      setSuccessMessage("Signup successful!");
      setLoading(false);
      handleSignupSuccess();
    })
    .catch((err) => {
      handleApiError(err, setError);
      setLoading(false);
    });
};

export const SignUpHGO = (
  values,
  setError,
  setLoading,
  handleSignupSuccess,
  setSuccessMessage
) => {
  Axios.post("/auth/register-hgo", values)
    .then((res) => {
      console.log("Signup response: ", res.data);
      setSuccessMessage(
        "Signup successful! Your account is waiting for approval."
      );
      setLoading(false);
      handleSignupSuccess();
    })
    .catch((err) => {
      setLoading(false);
      handleApiError(err, setError);
      console.error("Error during signup/approval:", err);
    });
};

export const GetRegisteredHGOs = (setHGOs, setError) => {
  Axios.get("/auth/register-hgos", getConfig())
    .then((res) => {
      const dataArray = res.data?.data?.data || [];
      if (Array.isArray(dataArray)) {
        // Filter out "Unclaimed" from the HGO list
        const filteredHGOs = dataArray.filter(hgo => hgo.name !== "Unclaimed");
        setHGOs(filteredHGOs);
      } else {
        setHGOs([]);
      }
      if (setError) {
        setError("");
      }
    })
    .catch((err) => {
      const errorMessage = err?.response?.data?.message || "Error fetching HGOs.";
      if (setError) {
        setError(errorMessage);
      }
      if (setHGOs) {
        setHGOs([]);
      }
    });
};

export const GetPendingHGOs = (
  setError,
  setLoading,
  setHGOs,
  page,
  setTotalPages
) => {
  Axios.get("/auth/pending-hgos?page=" + page, getConfig())
    .then((res) => {
      console.log("Login response: ", res.data);
      setHGOs(res.data.data.data);
      setTotalPages(res.data.data.pagination.totalPages);
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);
      setError(err.response.data.message);
      console.log("Error: ", err);
    });
};

export const GetPendingFilteredHGOs = (
  values,
  setError,
  setLoading,
  setHGOs,
  page,
  setTotalPages
) => {
  let params = "";
  {
    !!values?.date ? (params += `date=${values.date}&`) : (params = params);
  }
  Axios.get(
    "/auth/pending-hgos?page=" +
      page +
      "&" +
      params.substring(0, params.length - 1),
    getConfig()
  )
    .then((res) => {
      console.log("Login response: ", res.data);
      setHGOs(res.data.data.data);
      setTotalPages(res.data.data.pagination.totalPages);
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);
      setError(err.response.data.message);
      console.log("Error: ", err);
    });
};

export const ApproveHGO = (setError, setLoading, enrollment, handleApprove) => {
  return Axios.put("/auth/approve", { enrollment: enrollment }, getConfig())
    .then((res) => {
      console.log("Login response: ", res.data);
      setLoading(false);
      setError("");
      handleApprove(res.data?.data);
      return res;
    })
    .catch((err) => {
      setLoading(false);
      setError(err.response?.data?.message);
      ErrorToast(err.response?.data?.message);
      console.log("Error: ", err);
      throw err;
    });
};

export const ForgotPassword = (
  setLoading,
  email,
  enrollment,
  handleSuccess,
  setError
) => {
  Axios.post("/auth/forgot-password", { enrollment: enrollment, email: email })
    .then((res) => {
      console.log("Login response: ", res.data);
      setLoading(false);
      handleSuccess();
    })
    .catch((err) => {
      setLoading(false);
      handleApiError(err, setError);
      console.log("Error: ", err);
    });
};

export const ResetPassword = (
  setLoading,
  email,
  tempPass,
  password,
  handleSuccess,
  setError
) => {
  Axios.put("/auth/reset-password", {
    email: email,
    temporaryPassword: tempPass,
    newPassword: password,
  })
    .then((res) => {
      console.log("Login response: ", res.data);
      setLoading(false);
      handleSuccess();
    })
    .catch((err) => {
      setLoading(false);
      handleApiError(err, setError);
      console.log("Error: ", err);
    });
};

export const RejectHGO = (setError, setLoading, enrollment, handleReject) => {
  return Axios.put("/auth/reject", { enrollment: enrollment }, getConfig())
    .then((res) => {
      console.log("Login response: ", res.data);
      setLoading(false);
      setError("");
      handleReject(res.data?.data);
      return res;
    })
    .catch((err) => {
      setLoading(false);
      setError(err.response?.data?.message);
      ErrorToast(err.response?.data?.message);
      console.log("Error: ", err);
      throw err;
    });
};
